<template>
    <div class="catalog_item">
        <a :href="'/catalog/list' + basePath + '/' + category.category.catalog_code" class="catalog_item_name">{{ category.category.name }}</a>
        <div class="catalog_item_img">
            <img height="120" :src="'/catalog/icons' + brandPostfix  + '/' + category.category.catalog_code + '.svg'" alt="" />
            <div class="plus"></div>
        </div>
        <div class="catalog_item_content">
            <div class="catalog_item_list" >
                <span v-for="(scategory, index) in category.items" :key="scategory.id">
                    <p  v-if="index < maxVisible || showFull"><a :href="'/catalog/list' + basePath + '/' + scategory.catalog_code + '/' + scategory.human_url">{{ scategory.name }}</a></p>
                </span>
                <p class="text-more" v-if="category.items.length > maxVisible"><a href="javascript:void(0);" @click="showFull=true" v-if="showFull==false">еще {{ category.items.length - maxVisible }} категорий</a></p>
                <p class="text-more" v-if="category.items.length > maxVisible"><a href="javascript:void(0);" @click="showFull=false" v-if="showFull==true">скрыть {{ category.items.length - maxVisible }} категорий</a></p>
            </div>
            <a
                    :href="'/catalog/list' + basePath + '/' + category.category.catalog_code + '/' + category.category.human_url"
                    class="catalog_item_link hoverLineMoved"
            >
                Перейти к продуктам
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TopCatalogItem',
        props: ['category', 'basePath'],
        data() {
            return {
                showFull: false,
                maxVisible: 6
            }
        },
        computed: {
            brandPostfix(){
                return window.postfix
            }
        }
    }
</script>